import { useMutation, useQueryClient } from '@tanstack/react-query'

import { CreateInviteDTO } from '../lib/invites.types'
import { UsersService } from '../lib/users.service'
import { INVITES_LIST_QUERY_KEY } from './useInvites'

export const useCreateInvite = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: CreateInviteDTO) => {
      return UsersService.createInvite(params)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [INVITES_LIST_QUERY_KEY]
      })
    }
  })
}
